import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Drawer } from "@components/Drawer";
import { Content } from "./Content";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const SizeGuide = forwardRef(
  (
    {
      product,
      variant,
      data,
      isBra = false,
      selectedSize,
      sizes,
      showSizeGuide,
      closeSizeGuide,
      handleOptionChange,
      showFooter = true,
      addToCart,
      productTitle,
      comingSoon = false,
      waitlistMessage = null,
    },
    ref
  ) => {
    return (
      <Drawer isOpen={showSizeGuide}>
        {selectedSize && (
          <Header selectedSize={selectedSize} handleCloseDrawer={closeSizeGuide} />
        )}
        <Content
          product={product}
          sizes={sizes}
          isBra={isBra}
          data={data}
          selectedSize={selectedSize}
          handleOptionChange={handleOptionChange}
          showFooter={showFooter}
          ref={ref}
        />
        {showFooter && (
          <Footer
            addToCart={addToCart}
            variant={variant}
            productTitle={productTitle}
            comingSoon={comingSoon}
            waitlistMessage={waitlistMessage}
          />
        )}
      </Drawer>
    );
  }
);

SizeGuide.propTypes = {
  variant: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  isBra: PropTypes.bool,
  selectedSize: PropTypes.string.isRequired,
  sizes: PropTypes.array.isRequired,
  showSizeGuide: PropTypes.bool.isRequired,
  closeSizeGuide: PropTypes.func.isRequired,
  handleOptionChange: PropTypes.func.isRequired,
  addToCart: PropTypes.func,
  productTitle: PropTypes.string,
  comingSoon: PropTypes.bool,
  waitlistMessage: PropTypes.string,
};
